import { render, staticRenderFns } from "./qCardDetail.vue?vue&type=template&id=e51da700&scoped=true&"
import script from "./qCardDetail.vue?vue&type=script&lang=js&"
export * from "./qCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./qCardDetail.vue?vue&type=style&index=0&id=e51da700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51da700",
  null
  
)

export default component.exports